module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-nissan-24.f5a5ca10.jpg";